import useGetNewspaperConfig from './useGetNewspaperConfig'

export default useGetNewspaperConfig
